export const userRoutes = {
  label: 'Network Space',
  labelDisable: true,
  children: [
    {
      name: 'Roles',
      icon: 'key',
      to: '/roles',
      active: true,
      permission: 'Role.Read'
    },
    {
      name: 'Users',
      icon: 'users',
      to: '/users',
      active: true,
      permission: 'User.Read'
    },
    {
      name: 'Research',
      icon: 'search',
      children: [
        {
          name: 'Research by TIN',
          to: '/research/by-tin',
          active: true,
          permission: 'BillingGroup.Read'
        }],
      active: true,
    },
    {
      name: 'Network Owners',
      icon: 'user-circle',
      to: '/network-owners',
      active: true,
      permission: 'NetworkOwner.Read'
    },
    {
      name: 'Payers',
      icon: 'user-friends',
      active: true,
      to: '/payers',
      permission: 'Payer.Read'
    },
    {
      name: 'Networks',
      icon: 'network-wired',
      to: '/networks',
      active: true,
      permission: 'Network.Read'
    },
    {
      name: 'Contracting Entities',
      icon: 'star',
      to: '/organizations',
      active: true,
      permission: 'Organization.Read'
    },
    {
      name: 'Contracts',
      icon: 'pen-nib',
      to: '/contracts',
      active: true,
      permission: 'Contract.Read'
    },
    {
      name: 'Billing Groups',
      icon: 'file-invoice-dollar',
      to: '/billing-groups',
      active: true,
      permission: 'BillingGroup.Read'
    },
    {
      name: 'Practitioners',
      icon: 'user-md',
      to: '/practitioners',
      active: true,
      permission: 'Practitioner.Read'
    },
    {
      name: 'Facilities',
      icon: 'building',
      to: '/facilities',
      active: true,
      permission: 'Facility.Read'
    },
    {
      name: 'Locations',
      icon: 'map-pin',
      to: '/locations',
      active: true,
      permission:'Location.Read'
    },
    {
      name: 'Licensed LOS',
      icon: 'bookmark',
      to: '/licenses',
      active: true,
      permission: 'License.Read'
    },
    {
      name: 'Roster Loads',
      icon: 'upload',
      to: '/roster-loads',
      active: true,
      permission: 'RosterLoad.Read'
    }
  ]
};

export default [
  userRoutes
];
